import { Modal, Box, makeStyles, Typography, Button, SvgIconTypeMap } from '@material-ui/core';
import React, { Dispatch, SetStateAction } from 'react';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
	gameActionLink: {
		color: theme.palette.secondary.main,
		display: 'flex',
		marginBottom: theme.spacing(2),
		[theme.breakpoints.up('sm')]: {
			justifyContent: 'flex-end'
		},
		[theme.breakpoints.down('sm')]: {
			marginTop: theme.spacing(2)
		}
	},
	centralModal: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center'
	},
	modalBox: {
		background: '#FFFFFF',
		minHeight: '85vh',
		maxHeight: '85vh',
		overflowY: 'hidden',
		margin: '10vh',
		borderRadius: 4,
		[theme.breakpoints.down('sm')]: {
			minWidth: '95vw'
		},
		[theme.breakpoints.up('sm')]: {
			minWidth: '70vw',
			maxWidth: '70vw'
		}
	},
	jsonBox: {
		margin: '1vh'
	},
	modalToolbar: {
		backgroundColor: '#1976d2',
		color: 'white',
		paddingLeft: '1vw',
		paddingTop: '1vh',
		paddingBottom: '1vh',
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center'
	},
	modalDataCardHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		paddingBottom: '1vh'
	},
	centralBox: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		maxHeight: '80vh',
		minHeight: '80vh'
	},
	modalContent: {
		minHeight: '80vh',
		maxHeight: '80vh',
		padding: '1vw',
		paddingBottom: '0',
		display: 'flex',
		flexDirection: 'column'
	},
	titleBox: {
		display: 'flex',
		alignItems: 'center'
	}
}));

export const JsonDisplayModal: React.FC<JsonDisplayModalProps> = (props) => {
	const { title, open, setOpen, children, icon } = props;
	const classes = useStyles();

	return (
		<Modal
			open={open}
			className={classes.centralModal}
			onClose={(): void => {
				setOpen(false);
			}}>
			<Box className={classes.modalBox}>
				<Box className={classes.modalToolbar}>
					<Box className={classes.titleBox}>
						{icon}
						<Typography variant='h5' style={{ paddingLeft: '0.75vw' }}>
							{title}
						</Typography>
					</Box>
					<Button
						onClick={(): void => {
							setOpen(false);
						}}>
						<CloseIcon style={{ color: 'white', marginRight: '0.5vw' }} />
					</Button>
				</Box>
				<Box className={classes.modalContent}>{children}</Box>
			</Box>
		</Modal>
	);
};

type JsonDisplayModalProps = {
	title: string;
	open: boolean;
	setOpen: Dispatch<SetStateAction<boolean>>;
	icon: SvgIconTypeMap;
	children?: React.ReactNode;
};

export default JsonDisplayModal;
